var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"layout":"","justify-center":""}},[(_vm.gameGif)?_c('v-img',{class:[_vm.gameGif === 'fake.gif' ? 'fakeGifimg' : 'gifimg elevation-2'],attrs:{"src":_vm.pathGif + _vm.gameGif,"contain":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }